export const DEFAULT_MAX_IMAGE_UPLOAD_COUNT = 25;
export const DEFAULT_MAX_IMAGE_UPLOAD_SIZE_KB = 500;
export const DEFAULT_MAX_CONSTANTS_PER_WORKFLOW = 100;

// Settings related to the Services and their dependencies
export const DEFAULT_MAX_SERVICES = 10000;
export const DEFAULT_MAX_SERVICE_DEPENDENCIES = 30000;
export const DEFAULT_MAX_SERVICES_BEFORE_WARNING = 200;

// Flow Designer:
export const DEFAULT_MAX_CALLABLES_PER_FLOW_COUNT = 1;

// OnCall Group Shift Members
export const DEFAULT_MAX_ONCALL_GROUP_SHIFT_MEMBERSHIP = 200;

export const DEFAULT_INCIDENT_INSIGHT_SIMILAR_INCIDENT_POPUP_THRESHOLD = 0.99;
export const DEFAULT_INCIDENT_INSIGHT_RESOLVER_SCORE_THRESHOLD = 7;
export const DEFAULT_INCIDENT_INSIGHT_RESOLVER_SCORE_POPUP_THRESHOLD = 50;

// Help Drawer:
export const DEFAULT_HELP_VIEW_FOOTER_LINK_KNOWLEDGE_BASE_URL =
  'https://support.xmatters.com/hc/en-us/categories/13165761737371';
export const DEFAULT_HELP_VIEW_FOOTER_LINK_MOBILE_APP_URL =
  'https://help.xmatters.com/ondemand/#cshid=MobileApps';
export const DEFAULT_HELP_VIEW_FOOTER_LINK_SUPPORT_URL =
  'https://support.xmatters.com/hc/en-us/requests/new';
export const DEFAULT_HELP_VIEW_FOOTER_LINK_VIDEOS_URL =
  'https://help.xmatters.com/ondemand/#cshid=videos';
